export const UNCATEGORIZED = 'Uncategorized';

const MAX_CATEGORY_SEGMENTS = 6;

export const getDeviceListId = (device) =>
  String(device?.deviceId ?? device?.tvId ?? '').trim();

const stripHashFromSegment = (seg) =>
  String(seg).replace(/_[a-fA-F0-9]{6,}$/i, '').trim();

const isTechnicalSegment = (s) => {
  const t = String(s).toLowerCase();
  if (/^g\d+$/.test(t)) return true;
  if (/^\d+floor$/.test(t)) return true;
  if (/^floor\d+$/.test(t)) return true;
  if (/^tv\d*$/.test(t)) return true;
  if (/^room\d+$/.test(t)) return true;
  return false;
};

/**
 * Site-style category from device id (same rules as Screens tab).
 */
export const getScreenCategoryFromDeviceId = (rawId) => {
  const id = String(rawId ?? '').trim();
  if (!id || !id.includes('-')) return UNCATEGORIZED;

  const parts = id.split('-').map(stripHashFromSegment).filter((p) => p.length > 0);
  if (parts.length < 2) return UNCATEGORIZED;

  const head = parts[0];
  if (!/^[A-Za-z][A-Za-z0-9]+$/.test(head) || head.length < 2) return UNCATEGORIZED;

  const tail = parts.slice(1);
  if (!tail.every((seg) => /^[A-Za-z0-9_]+$/.test(seg))) return UNCATEGORIZED;

  let end = parts.length;
  for (let i = 2; i < parts.length; i++) {
    if (isTechnicalSegment(parts[i])) {
      end = i;
      break;
    }
  }

  let keyParts = parts.slice(0, Math.max(2, end));
  if (keyParts.length > MAX_CATEGORY_SEGMENTS) {
    keyParts = parts.slice(0, MAX_CATEGORY_SEGMENTS);
  }
  return keyParts.join('-');
};

export const formatCategoryLabel = (categoryKey) => {
  if (!categoryKey || categoryKey === UNCATEGORIZED) return UNCATEGORIZED;
  const p = categoryKey.split('-');
  if (p.length === 1) return p[0];
  return `${p[0]} — ${p.slice(1).join(' · ')}`;
};

export const categorySortKey = (cat) => (cat === UNCATEGORIZED ? '\uffff' : cat);
